import React from 'react'
import ThingsToDoBanner from './ThingsToDoBanner'
import TravelAndTours from './TravelAndTours'
import ExcitementSeeking from '../hotel/ExcitementSeeking'
import PopularThings from './PopularThings'
import LocalMusic from './LocalMusic'
import EscapeRoom from './EscapeRoom'
import FamilyTopAttractions from './FamilyTopAttractions'
import Winery from './Winery'
import Comedy from './Comedy'
import PopularEntermaintIndex from './PopularEntermaintIndex'
import HomeSportsTickets from '../home/HomeSports'
import Favorite from '../../../assets/images/Favorite-bg5.png'

export default function ThingsTODOIndex() {
  return (
    <>
      <ThingsToDoBanner />
      <TravelAndTours />
      <ExcitementSeeking />
      <HomeSportsTickets/>
      <PopularEntermaintIndex/>
      <PopularThings />
      <LocalMusic />
      <EscapeRoom />
      <FamilyTopAttractions />
      <Winery />
      <Comedy />
      <section className="section-equal-padding favorite-section things-favorite"
        style={{ backgroundImage: `url(${Favorite})` }}>
        <div className="container d-flex justify-content-center text-center">
          <div className="favorite-block "
            style={{ maxWidth: '100%' }}
            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false" >
            <h2 className="mb-4">Get Ready for an Adventure!</h2>
            <p>
              Start your journey with us, where we guarantee the lowest prices. Book top hotel rooms for $20-$30
              less per night and save $25-$50 on flights compared to other travel sites. Explore our site, grab
              great deals, and let the thrill of savings fuel your dream getaway!
            </p>
            <a href="" className="white-btn mt-3">Browse Full Menu</a>
          </div>
        </div>
      </section>
    </>
  )
}
